import { useState } from 'react'

import {
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  PaginationState,
  useReactTable,
  type TableOptions,
} from '@tanstack/react-table'

import { fuzzyFilterFn } from './helper'
import type { DataTableFilterField } from './types'

interface UseDataTableProps<TData>
  extends Omit<TableOptions<TData>, 'getCoreRowModel' | 'filterFns'> {
  filterFields?: DataTableFilterField<TData>[]
}

export function useDataTable<TData>({
  filterFields = [],
  ...props
}: UseDataTableProps<TData>) {
  const table = useReactTable({
    ...props,
    filterFns: {
      fuzzy: fuzzyFilterFn,
    },
    globalFilterFn: 'fuzzy',
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
  })

  return { table }
}

export function useServerDataTable<TData>({
  filterFields = [],
  ...props
}: UseDataTableProps<TData>) {
  const table = useReactTable<TData>({
    ...props,
    filterFns: {
      fuzzy: fuzzyFilterFn,
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    manualPagination: true,
    manualFiltering: true,
    manualSorting: true,
  })

  return { table }
}
